<script>
import { mapState, mapActions, mapGetters } from "vuex";
import ClientFactory from "@/api/ClientFactory";
import { VueGoodTable } from 'vue-good-table';
const dropdownsApi = ClientFactory.get("dropdowns");

const emulationApi = ClientFactory.get("emulations");

export default {
  components: {
      VueGoodTable
  },
  data(){
    return {
      emulation_id :null,
      fullname:'',
      employee_id:null,
      emulation_group_id:null,
      total: 0,
      department_id: null,
      year: null,
      currentMonth: null,
      total_point_self_rating: 0,
      approver_status:null,
      approver:null,
      self_note:"",
      department_note:"",
      columns: [
        {
          label: 'STT',
          field: 'rownum',
          thClass: 'text-center width-class',
          tdClass: 'text-center width-class',
        },
        {
          label: 'Tiêu chí/Nội dung',
          field: 'target_name',
          thClass: 'text-center',
          tdClass: 'text-left',
        },
        {
          label: 'Thang điểm (trừ)',
          field: 'point',
          thClass: 'text-center width-point',
          tdClass: 'text-center width-point',
        },
        {
          label: 'Điểm tự chấm',
          field: 'self_point',
          headerField: this.sumCount,
          
          thClass: 'text-center width-point',
          tdClass: 'text-center width-point',
        },
      ],
       data: [
      ],
      data_update: [
      ],
      years: [],
      months: [
        {
          value: 1,
          label: "Tháng 1",
        },
        {
          value: 2,
          label: "Tháng 2",
        },
        {
          value: 3,
          label: "Tháng 3",
        },
        {
          value: 4,
          label: "Tháng 4",
        },
        {
          value: 5,
          label: "Tháng 5",
        },
        {
          value: 6,
          label: "Tháng 6",
        },
        {
          value: 7,
          label: "Tháng 7",
        },
        {
          value: 8,
          label: "Tháng 8",
        },
        {
          value: 9,
          label: "Tháng 9",
        },
        {
          value: 10,
          label: "Tháng 10",
        },
        {
          value: 11,
          label: "Tháng 11",
        },
        {
          value: 12,
          label: "Tháng 12",
        },
      ],
      departments: [],
      state: [true, false]
    };
  },
  async created() {
    this.years = await dropdownsApi.get(dropdownsApi.type.YEARS);
    this.departments = await dropdownsApi.get(dropdownsApi.type.DEPARTMENTS);    
    this.getDetail();
  },
  methods: {
    ...mapActions("ui", ['loading', 'closeLoading', 'notify']),
    getDetail: async function () {
      this.emulation_id = this.$route.params.id || -1;
      if(this.emulation_id < 1 || isNaN(this.emulation_id)) {
        return this.$router.push('/emulation/list').catch(() => {})
      }
      this.loading(this.$vs);
      const { data } = await emulationApi.getDetail(this.emulation_id);
      this.closeLoading();
      this.checkResponseData(data);
    },
    selectionChanged(params){
      console.log(params);
    },
    getInfo(row){
      if(!row.checked){
        row.self_point = 0;
      }
      else{ 
        row.self_point = Math.abs(row.point);
      }
      let index = this.data.findIndex(c => c.target_id === row.target_parent_id);
      if(index > -1) {
          const indexChildren = this.data[index].children.findIndex(c => c.target_id === row.target_id);
          if(indexChildren > -1) {
            this.data[index].children[indexChildren].checked = !this.data[index].children[indexChildren].checked;
            this.data[index].children[indexChildren].self_point = row.self_point;
          }
          //Tính tổng gán vào title
          let sum = 0;
          this.data[index].children.forEach(x => {
              sum += x.self_point;
          });
          this.data[index].self_point =sum;
      }
    },
    sumCount: function (rowObj) {
      let sum = 0;
      let target_parent_id = -1;
      for (let i = 0; i < rowObj.children.length; i++) {
        sum += rowObj.children[i].self_point;
        target_parent_id = rowObj.children[i].target_parent_id;
      }
      // const indexChildren = this.data.findIndex(c => c.target_id === target_parent_id);
      // console.log(indexChildren);
      // if(indexChildren > -1) {
      //   this.data[indexChildren].self_point = sum;
      // }

      //rowObj.self_point = sum;
      return sum;
    },
    checkResponseData(data) {
      console.log(data.data[0]);
      if(data.status == "success")
      {
        if(this.emulation_id < 1 || isNaN(this.emulation_id)) {
          return this.$router.push('/emulation/list').catch(() => {})
        }
        
        this.data_update = data.data[0].title_targets;
        this.data = JSON.parse(JSON.stringify(this.data_update));
        this.emulation_id = data.data[0].emulation_info[0].id;
        this.employee_id = data.data[0].emulation_info[0].employee_id;
        this.emulation_group_id = data.data[0].emulation_info[0].emulation_group_id;
        this.fullname = data.data[0].emulation_info[0].full_name;
        this.department_id = data.data[0].emulation_info[0].department_id;
        this.year = data.data[0].emulation_info[0].year;
        this.currentMonth = data.data[0].emulation_info[0].month;
        this.self_note = data.data[0].emulation_info[0].self_note;
        this.department_note = data.data[0].emulation_info[0].department_note;
        this.approver_status = data.data[0].emulation_info[0].approver_status;
        this.approver = data.data[0].emulation_info[0].approver;
      }else{
        // this.notify({
        //   error:true,
        //   title: data.status,
        //   text: data.message
        // });
        return this.$router.push('/emulation/list').catch(() => {});
      }
     },

    rowStyleClassFn(row) {
      return row.is_title > 0 ? 'header-row' : '';
    },
    async saveSelfRating(approver_status) {
      this.loading(this.$vs);
      //send to server
      let response = await emulationApi.updateEmulation({
        id:this.emulation_id,
        employee_id:this.employee_id,
        emulation_group_id:this.emulation_group_id,
        department_id:this.department_id,
        year:this.year,
        month:this.currentMonth,
        self_note:this.self_note,
        department_note:this.department_note,
        approver_status:approver_status,
        approver:this.approver,
        status:1,
        type:0, //Cá nhân chấm
        targets: this.data
      });
      this.closeLoading();
      if(response.data.status === 'failed') {
          return this.notify({
              error: true,
              text: response.error || response.data.message,
          })
      }
      if(response.data.status === 'success') {
          this.notify({
              success: true,
              text: response.data.data[0].error_message,
          });
      }
      this.$router.push('/emulation/list');
     },

  },
  computed: {
    ...mapState("auth", ["AppActiveUser"]),
  //   setCheckbox(id) {
  //     if(this.data)

  //   }
   },
  destroyed() {
    this.closeLoading();
  }
};

</script>

<template>
  <div class="self_rating_edit">
    <CCard class= "mb-2">
      <CCardHeader  class="pt-1 pb-1">
        <h4>Chấm điểm thi đua tháng</h4>
      </CCardHeader>
      <CCardBody class="pt-1 pb-2">
        <CRow>
            <CCol sm="3">
              <label>Họ và tên</label>
              <CInput
                :value.sync="fullname"
                :disabled="true"
                />
            </CCol>
            <CCol sm="3">
              <label>Phòng ban</label>
              <CSelect
                :options='departments'
                :value.sync="department_id"
                :disabled="true"
              />
            </CCol>
            <CCol sm="2">
              <label>Năm</label>
              <CSelect
                :options=years
                :value.sync="year"
                :disabled="true"
              />
            </CCol>
            <CCol sm="2">
              <label>Tháng</label>
              <CSelect
                :options=months
                :value.sync="currentMonth"
                :disabled="true"
              />
            </CCol>
        </CRow>
      </CCardBody>
    </CCard>
    <CCard>
      <vue-good-table
        :columns="columns"
        :rows="data_update" 
        :group-options="{
          enabled: true,
          headerPosition: 'top'
        }"
        :sort-options="{
          enabled:false
        }"
        :row-style-class="rowStyleClassFn"
      >
        <div slot="emptystate">
          Không có dữ liệu
        </div>
        <template
          slot="table-row"
          slot-scope="props"
        >
            <div v-if="props.column.field === 'point'">
                <span v-if="props.row.is_title != 1">-{{props.row.point}}</span>
            </div>
            <div v-else-if="props.column.field === 'self_point'" class="checkbox-left">
                <div v-if="props.row.is_title != 1">
                  <!-- <vs-checkbox v-model="props.row.checked" :value="props.row.checked" @click="getInfo(props.row)">
                  </vs-checkbox> -->
                  <vs-checkbox v-model="props.row.checked" :value="props.row.checked" @click="getInfo(props.row)">
                  </vs-checkbox>
                </div>
            </div>
            
        </template>
      </vue-good-table> 
      <CTextarea
          label="Ghi chú"
          placeholder="Nhập ghi chú"
          :value.sync="self_note"
          class="p-2"
          />
      <CCardFooter>
        <CRow>
          <vs-button square class="custom_btn_search"  @click="()=> {this.$router.go(-1)}"><i class='bx bx-left-arrow-alt'></i> &nbsp; Quay lại</vs-button>
          <vs-button color="success" square class="float-left md:mt-2" @click="saveSelfRating(2)"><i class='bx bx-save' ></i> &nbsp; Lưu nháp</vs-button>
          <vs-button square class="float-left md:mt-2" @click="saveSelfRating(0)"><i class='bx bx-save' ></i> &nbsp; Lưu và Gửi duyệt</vs-button>
        </CRow>
      </CCardFooter>
    </CCard>
    
  </div>
</template>

<style lang="scss">
  .self_rating_edit{
    .width-class{
      min-width: 3px !important;
    }
    .width-point{
      min-width: 30px !important;
    }
    .header-row {
      background: #f7f8f9;
      color: red;
      font-weight: bold;
    }
    .vs-checkbox-content{
      align-items: center;
      justify-content: center;
    }
    .checkbox-left{
      text-align: left;
    }
  }
</style>